module.exports = __webpack_public_path__ + "assets/img/banner.b1e0f694.png";